export default "__VITE_ASSET__CTpR4jR7__"